import { Box, Text } from '@chakra-ui/react'
import { ModalBuild } from 'components/molecules'
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces'
import { ReactNode, RefObject } from 'react'

interface PropsConfirmationModal {
    handleConfirm: () => void
    text?: string
    refModal: RefObject<ModalBuildHandle>
    handleCancel: () => void
    title?: string
    btnCancelOrBack?: string
    btnConfirm?: string
    children?: ReactNode
}

const defaultText =
    'Você realmente deseja deletar? Uma vez deletado, não será possível voltar atrás.'
const defaultTitle = 'Confirmação de exclusão'
const defaultActionCancelOrBack = 'Cancelar'
const defaultActionConfirm = 'Deletar'
export function ConfirmationModal({
    handleConfirm,
    handleCancel,
    text = defaultText,
    refModal,
    title = defaultTitle,
    btnConfirm = defaultActionConfirm,
    btnCancelOrBack = defaultActionCancelOrBack,
    children
}: PropsConfirmationModal) {
    return (
        <ModalBuild
            ref={refModal}
            closeOnOverlayClick={false}
            title={title}
            size="md"
            actions={{
                position: 'flex-end',
                childrens: [
                    {
                        text: btnCancelOrBack,
                        handle: 'cancel',
                        variant: 'outline'
                    },
                    {
                        text: btnConfirm,
                        handle: 'confirm',
                        colorScheme: 'red'
                    }
                ]
            }}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
        >
            <Box px={8} py={4}>
                <Text fontSize="18">{text}</Text>
                {children}
            </Box>
        </ModalBuild>
    )
}
